import { Box, styled, Typography } from '@mui/material';

export const Container = styled(Box)(
  ({ $showUnderline, theme }) => `
    height: 41px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    
    ${
      $showUnderline
        ? `border-bottom: 1px solid ${theme.palette.secondary.dark};`
        : ``
    };
    
`,
);

export const Title = styled(Typography)`
  font-size: 1.25rem;
  font-weight: 400;
`;
